export enum Sizes {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}
